import { render } from "./WebShopDaten.vue?vue&type=template&id=010236b0&scoped=true&ts=true"
import script from "./WebShopDaten.vue?vue&type=script&lang=ts"
export * from "./WebShopDaten.vue?vue&type=script&lang=ts"

import "./WebShopDaten.vue?vue&type=style&index=0&id=010236b0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010236b0"]])

export default __exports__